/**
 * This file includes the functions to parse and define actions
 * @auther lampralex
 */

/**
 * extractInternalAction - this function extract the predefined
 * internal actions and arguments from a html element
 * @param {HTMLElement} element the html element to be parsed
 * @return {Jsobject}  an object representing the available internal actions
 */
function extractInternalAction(element) {
  const internalAction = {
    changePage: ''
  };
  if (
    element.getAttribute('target_page') !== 'undefined' &&
    element.getAttribute('target_page') !== null
  ) {
    internalAction.changePage = element.getAttribute('target_page');
  }
  return internalAction;
}

/**
 * extractExternalAction - this function extract the predefined external
 * action such as a link to another page from html element's arguments
 * @paran {HTMLElement} element the html element to be parsed
 * @return {Jsobject} an object representing the available external actions
 */
function extractExternalAction(element) {
  const externalAction = {
    linkHref: element.getAttribute('href') || ''
  };
  return externalAction;
}

/**
 *
 */
function extractCustomCode(element) {
  const customCode = {
    functionName: element.getAttribute('customcode') || ''
  };
  return customCode;
}

export { extractInternalAction, extractExternalAction, extractCustomCode };
